import React from 'react';
import LandingSection from './LandingSection';
import LandingCard from './LandingCard';
import { FAQ_ITEMS } from './landingData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

export default function LandingFAQ() {
  return (
    <LandingSection
      id="faq"
      title="FAQ"
      subtitle="Quick answers to common questions."
      innerClassName=""
      withTopDivider
    >
      <LandingCard className="p-2 sm:p-3" hover={false}>
        <Accordion type="single" collapsible className="w-full">
          {FAQ_ITEMS.map((item) => (
            <AccordionItem key={item.q} value={item.q} className="border-white/10">
              <AccordionTrigger className="px-3 text-left text-white hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="px-3 pb-4 text-sm text-white/60">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </LandingCard>
    </LandingSection>
  );
}

